import { smartDm } from '@shopmy/universal';

export const TIPS = {
  shadow: 'The platform is in shadow. The comment qualified for a DM, and nothing was sent. Shadow is one switch for everyone, not a per-creator setting.',
  skipped: 'A decision not to send. The comment was read and dropped on purpose: no ask for a link, already answered, a collection that is archived, a product page that is gone, the hourly cap, or a switch that is off.',
  failed: 'A send was attempted and broke. Either there is no Instagram token, or Instagram rejected the reply. These are the rows worth chasing.',
  received: 'Saved, and the worker never wrote an outcome. A new one is still in flight. One that is minutes old is stuck.'
};

export const REASONS = {
  intent_none: 'Not asking for a link',
  intent_product_question: 'Asking about size, price, or restock',
  below_confidence: 'Looked like a link request, under 80% confident',
  classifier_unavailable: 'Classifier returned nothing',
  commenter_already_handled: 'Already DMed this person on this post',
  destination_private: 'Collection is archived',
  destination_dead: 'Product is no longer available',
  destination_missing: 'Link or collection is gone',
  hourly_cap: 'Hourly cap',
  setting_disabled: 'Their switch is off',
  flag_off: 'Feature flag off',
  no_token: 'No Instagram Login token',
  ig_error: 'Instagram rejected the reply',
  worker_error: 'Failed before reaching Instagram'
};

export const isStorySend = send => smartDm.STORY_SOURCES.includes(send?.sourceType);

export const storyTimeLabel = (expiresAt, now = Date.now()) => {
  if (!expiresAt) return null;
  const remainingMs = new Date(expiresAt).getTime() - now;
  if (!Number.isFinite(remainingMs) || remainingMs <= 0) return 'Expired';
  if (remainingMs < 60 * 60 * 1000) return `${Math.min(59, Math.max(1, Math.ceil(remainingMs / 60000)))}m left`;
  return `${Math.floor(remainingMs / 3600000)}h left`;
};

export const whyFor = send => {
  if (send.status === 'sent') {
    const confidence = send.confidence == null ? '' : ` · ${Math.round(send.confidence * 100)}% confident`;
    return `Asked for the link${confidence}`;
  }
  if (send.status === 'shadow') return 'Would have sent. Shadow is on, so no DM went out.';
  if (send.status === 'received') return 'No outcome written';
  if (send.reasonKey === 'commenter_already_handled') {
    return isStorySend(send) ? 'Already DMed this person on this story' : REASONS.commenter_already_handled;
  }
  if (send.reasonKey && REASONS[send.reasonKey]) return REASONS[send.reasonKey];
  return send.statusMsg || '';
};

export const bannerFor = creator => {
  if (!creator.flagOn) return 'The feature flag is off, so ShopMy DM is hidden for them and the worker skips every comment.';
  if (creator.eligibility === 'legacy_facebook_login') {
    return 'Connected through Facebook. No DM can go out until they reconnect Instagram directly, even though Instagram looks connected everywhere else in ShopMy.';
  }
  if (creator.eligibility === 'missing_scopes') return 'Comments or messages were turned off when they connected. Nothing sends until they reconnect and keep both on.';
  if (creator.eligibility === 'token_expired' || creator.eligibility === 'no_instagram') return 'No DM can go out until they reconnect Instagram.';
  if (!creator.switchOn) return 'ShopMy DM is switched off on their account, so the worker records the comment and does not send.';
  if (!creator.connectedPostCount) return 'Nothing sends until they connect a post.';
  return null;
};

export const BLOCKED_LABELS = {
  switch: 'Their switch is off',
  reconnect: 'Instagram needs reconnecting',
  facebook: 'Connected through Facebook',
  scopes: 'Missing Instagram permissions',
  no_instagram: 'No Instagram connected'
};

export const instagramChip = creator => {
  if (creator.eligibility === 'legacy_facebook_login') return { off: true, label: BLOCKED_LABELS.facebook };
  if (creator.eligibility === 'missing_scopes') return { off: true, label: BLOCKED_LABELS.scopes };
  if (creator.eligibility === 'token_expired') return { off: true, label: BLOCKED_LABELS.reconnect };
  if (creator.eligibility === 'no_instagram') return { off: true, label: BLOCKED_LABELS.no_instagram };
  return { off: false, label: 'Instagram connected' };
};
